import React from 'react';

import styles from './Statistics.module.scss';
import { useTranslate } from 'react-polyglot';
import { Accordion } from 'react-bootstrap';
import StatisticsHealth from './StatisticsAreas/StatisticsHealth/StatisticsHealth';
import StatisticsRelationship from './StatisticsAreas/StatisticsRelationship/StatisticsRelationship';
import StatisticsUse from './StatisticsAreas/StatisticsUse/StatisticsUse';
import StatisticsExterior from "./StatisticsAreas/StatisticsExterior/StatisticsExterior";

function Statistics(props: StatisticsProps) {
    const t = useTranslate();

    const [hasDataHealth, setHasDataHealth] = React.useState<boolean>(false);
    const [hasDataRelationship, setHasDataRelationship] = React.useState<boolean>(false);
    const [hasDataUse, setHasDataUse] = React.useState<boolean>(false);
    const [hasDataExterior, setHasDataExterior] = React.useState<boolean>(false);

    return (
        <div className="maincontent">
            <div className={styles.statistics}>
                <h1>{t("statistics.title")}</h1>
                <hr/>
                <Accordion className={styles.accordion} defaultActiveKey="0">
                    <Accordion.Item className={styles.accordionitem} eventKey="0" style={{ display: hasDataHealth ? "block" : "none" }}>
                        <Accordion.Header className={styles.accordionheader}>{t("statistics.areas.health.title")}</Accordion.Header>
                        <Accordion.Body>
                            <StatisticsHealth
                                onDataLoaded={(hasData) => {
                                    if (hasData) {
                                        setHasDataHealth(true);
                                    } else {
                                        setHasDataHealth(false);
                                    }
                                }}
                            />
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item className={styles.accordionitem} eventKey="1" style={{ display: hasDataRelationship ? "block" : "none" }}>
                        <Accordion.Header className={styles.accordionheader}>{t("statistics.areas.relationship.title")}</Accordion.Header>
                        <Accordion.Body>
                            <StatisticsRelationship
                                onDataLoaded={(hasData) => {
                                    if (hasData) {
                                        setHasDataRelationship(true);
                                    } else {
                                        setHasDataRelationship(false);
                                    }
                                }}
                            />
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item className={styles.accordionitem} eventKey="2" style={{ display: hasDataUse ? "block" : "none" }}>
                        <Accordion.Header className={styles.accordionheader}>{t("statistics.areas.use.title")}</Accordion.Header>
                        <Accordion.Body>
                            <StatisticsUse
                                onDataLoaded={(hasData) => {
                                    if (hasData) {
                                        setHasDataUse(true);
                                    } else {
                                        setHasDataUse(false);
                                    }
                                }}
                            />
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item className={styles.accordionitem} eventKey="3" style={{ display: hasDataExterior ? "block" : "none" }}>
                        <Accordion.Header className={styles.accordionheader}>{t("statistics.areas.exterior.title")}</Accordion.Header>
                        <Accordion.Body>
                            <StatisticsExterior
                                onDataLoaded={(hasData) => {
                                if (hasData) {
                                    setHasDataExterior(true);
                                } else {
                                    setHasDataExterior(false);
                                }
                            }}
                                />
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
            </div>
        </div>
    );
}

class StatisticsProps {
    
}

export default Statistics;
